import { ParsedUrlQueryInput, stringify } from 'querystring';

import config from 'config';

const { cfCustomerSubdomain } = config;

const getCloudflareVideoThumbnail = (uid: string, query: ParsedUrlQueryInput = {}) =>
  `https://customer-${cfCustomerSubdomain}.cloudflarestream.com/${uid}/thumbnails/thumbnail.jpg?${stringify(query)}`;

export default getCloudflareVideoThumbnail;
